import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const reviews = [
  {
    name: 'Marius Vintila',
    time: '3 months ago',
    service: 'EV Charger',
    text: 'We chose EV Made Easy for our home EV charger installation, and they exceeded our expectations. Our installer, Tom, was truly exceptional. He was professional, highly skilled, and ensured the job was completed to the highest standard.',
  },
  {
    name: 'Shumyla P',
    badge: 'Local Guide',
    time: '1 month ago',
    service: 'EV Charger',
    text: 'Exceptional service by Babak. Exceeded my expectation when he fixed a rather complicated job. Highly professional and has an eye to detail. Kept communicating all day updating on his ETA. I\'d rate him 10/10.',
  },
  {
    name: 'Daniel Lake',
    badge: 'Local Guide',
    time: '5 months ago',
    service: 'EV Charger',
    text: 'Babak and his team did a great job of installing my EV charger. It only took about 2 hours and they left everything clean and tidy. Babak even took the time to show me how to use the app and how to charge my car.',
  },
  {
    name: 'V C',
    badge: 'Local Guide',
    time: '3 weeks ago',
    service: 'EV Charger',
    text: 'EV Made Easy installed my EV charger. I am very pleased with the excellent service provided. Tom the electrician offered good advice and did a super job. Highly recommend.',
  },
  {
    name: 'Scott Morgan',
    time: '6 months ago',
    service: 'EV Charger',
    text: 'Easy and fast process of ordering and booking the fitting. All done and fitted within a week and a half. Nice polite and professional installer (Howard), good quality job and tidy finish. Would definitely recommend.',
  },
  {
    name: 'Shabz',
    time: '3 months ago',
    service: 'EV Charger',
    text: 'I had my Ohme charger installed by an EV Made Easy installer today. The process was smooth from start to finish, excellent and beautifully done with full care and effort. The whole team went the extra mile.',
  },
];

function StarRow({ size = 'text-sm' }: { size?: string }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((s) => (
        <i key={s} className={`ri-star-fill text-[#FFB800] ${size}`} />
      ))}
    </div>
  );
}

export default function SocialProof() {
  const headingAnim = useScrollAnimation();
  const cardsAnim = useScrollAnimation();

  return (
    <section className="bg-[#f7f8fa] py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Heading + Google badge */}
        <div
          ref={headingAnim.ref}
          className={`text-center mb-10 transition-all duration-700 ${headingAnim.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <div className="text-xs font-bold uppercase tracking-widest text-[#4CAF50] mb-2">GOOGLE REVIEWS</div>
          <h2 className="font-heading font-black text-2xl md:text-3xl text-[#1F2933] mb-4">
            What our customers say
          </h2>

          {/* Google Rating Badge */}
          <a
            href="https://share.google/fbMmoctdetcjPCoMq"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white border border-gray-200 rounded-2xl px-5 py-3 hover:border-[#4CAF50] hover:-translate-y-0.5 transition-all duration-200 cursor-pointer group"
          >
            {/* Google G logo */}
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
              <svg viewBox="0 0 48 48" className="w-7 h-7">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                <path fill="none" d="M0 0h48v48H0z"/>
              </svg>
            </div>
            <div className="text-left">
              <div className="flex items-center gap-2">
                <span className="font-black text-[#1F2933] text-xl leading-none">5.0</span>
                <StarRow size="text-base" />
              </div>
              <div className="text-gray-500 text-xs mt-0.5 group-hover:text-[#4CAF50] transition-colors">
                449 Google reviews — read them all
              </div>
            </div>
            <div className="w-5 h-5 flex items-center justify-center ml-1">
              <i className="ri-external-link-line text-gray-400 group-hover:text-[#4CAF50] text-sm transition-colors" />
            </div>
          </a>
        </div>

        {/* Review cards */}
        <div ref={cardsAnim.ref}>
          {/* Mobile: swipe slider */}
          <div className="md:hidden">
            <div className="flex items-center justify-end mb-3 px-0.5">
              <span className="text-[11px] text-[#4CAF50] font-semibold flex items-center gap-1">
                <i className="ri-drag-move-line text-xs" /> Swipe reviews
              </span>
            </div>
            <div className="flex overflow-x-auto gap-3 snap-x snap-mandatory pb-4 [&::-webkit-scrollbar]:hidden -mx-4 px-4">
              {reviews.map((r, i) => (
                <div
                  key={i}
                  className="snap-start flex-shrink-0 w-[82vw] bg-white rounded-xl p-5 flex flex-col border border-gray-100"
                >
                  <div className="flex items-start justify-between gap-2 mb-3">
                    <div className="flex items-center gap-2">
                      <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#145A32] text-white font-bold text-sm flex-shrink-0">
                        {r.name.charAt(0)}
                      </div>
                      <div>
                        <div className="font-bold text-sm text-[#1F2933] leading-tight">{r.name}</div>
                        <div className="flex items-center gap-1.5">
                          {r.badge && <span className="text-[10px] text-[#4CAF50] font-semibold">{r.badge}</span>}
                          <span className="text-[10px] text-gray-400">{r.time}</span>
                        </div>
                      </div>
                    </div>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <svg viewBox="0 0 48 48" className="w-4 h-4">
                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                        <path fill="none" d="M0 0h48v48H0z"/>
                      </svg>
                    </div>
                  </div>
                  <StarRow />
                  <p className="text-[#1F2933] text-sm leading-relaxed flex-1 mt-3 mb-4">&ldquo;{r.text}&rdquo;</p>
                  <div className="flex items-center gap-1.5 mt-auto">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-ev-charging-line text-[#4CAF50] text-xs" />
                    </div>
                    <span className="text-xs text-gray-400">{r.service}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex justify-center gap-1.5 mt-1">
              {reviews.map((_, i) => (
                <div
                  key={i}
                  className={`rounded-full transition-all ${i === 0 ? 'w-4 h-1.5 bg-[#4CAF50]' : 'w-1.5 h-1.5 bg-gray-300'}`}
                />
              ))}
            </div>
          </div>

          {/* Desktop: 3-col grid */}
          <div className="hidden md:grid grid-cols-3 gap-4">
            {reviews.map((r, i) => (
              <div
                key={i}
                style={{ transitionDelay: `${i * 80}ms` }}
                className={`bg-white rounded-xl p-5 flex flex-col border border-gray-100 hover:border-[#4CAF50]/30 hover:-translate-y-1 transition-all duration-300 ${cardsAnim.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              >
                <div className="flex items-start justify-between gap-2 mb-3">
                  <div className="flex items-center gap-2">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#145A32] text-white font-bold text-sm flex-shrink-0">
                      {r.name.charAt(0)}
                    </div>
                    <div>
                      <div className="font-bold text-sm text-[#1F2933] leading-tight">{r.name}</div>
                      <div className="flex items-center gap-1.5">
                        {r.badge && <span className="text-[10px] text-[#4CAF50] font-semibold">{r.badge}</span>}
                        <span className="text-[10px] text-gray-400">{r.time}</span>
                      </div>
                    </div>
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg viewBox="0 0 48 48" className="w-4 h-4">
                      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                      <path fill="none" d="M0 0h48v48H0z"/>
                    </svg>
                  </div>
                </div>
                <StarRow />
                <p className="text-[#1F2933] text-sm leading-relaxed flex-1 mt-3 mb-4">&ldquo;{r.text}&rdquo;</p>
                <div className="flex items-center gap-1.5 mt-auto">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-ev-charging-line text-[#4CAF50] text-xs" />
                  </div>
                  <span className="text-xs text-gray-400">{r.service}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://share.google/fbMmoctdetcjPCoMq"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 border-2 border-[#4CAF50] text-[#4CAF50] font-bold px-7 py-3 rounded-full text-sm hover:bg-[#4CAF50] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-xs" />
            </div>
            Read all 449 reviews on Google
          </a>
          <button
            onClick={() => document.getElementById('quote-section')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-[#145A32] to-[#4CAF50] text-white font-bold px-7 py-3 rounded-full text-sm hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
          >
            Get a free quote
          </button>
        </div>
      </div>
    </section>
  );
}
